import AmpersandCollection from 'ampersand-collection';
import ActivityModel from './recent-activity-model';
import _ from 'lodash';


var ActivitiesCollection = AmpersandCollection.extend({
    model: ActivityModel,

    groupByDay() {
        return _.chain(this.models)
            .groupBy(function(m){
                return m.date.format("YYYY-MM-DD");
            })
            .toPairs()
            .map(function(currentItem) {
                return _.fromPairs(_.zip(['date', 'activities'], currentItem));
            })
            .sortBy('date')
            .reverse()
            .value();
    }

});

module.exports = ActivitiesCollection;